function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M18.2,1h65.7C93.3,1,101,8.7,101,18.2v65.7 c0,9.5-7.7,17.2-17.2,17.2H18.2C8.7,101,1,93.3,1,83.8V18.2C1,8.7,8.7,1,18.2,1z"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 45.5,
  y1: 34.3,
  x2: 100.5,
  y2: 34.7
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 0.5,
  y1: 33.9,
  x2: 22.9,
  y2: 34.1
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 0.5,
  y1: 67.3,
  x2: 100.5,
  y2: 68.1
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 67.8,
  y1: 0.5,
  x2: 67.8,
  y2: 100.5
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 34.2,
  y1: 45.5,
  x2: 34.2,
  y2: 100.5
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 34.2,
  y1: 0.5,
  x2: 34.2,
  y2: 22.9
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  cx: 34.2,
  cy: 34.2,
  r: 11.3
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  cx: 34.2,
  cy: 67.6,
  r: 11.3
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  cx: 67.8,
  cy: 34.2,
  r: 11.3
});

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 102",
    enableBackground: "new 0 0 102 102",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.bd3d1fd3.svg";
export { ForwardRef as ReactComponent };